// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1ZUg3","description":"PatientConsentPreview_description__1Hta-"};